import '@Global/download-publish-dialog';
import '@Global/modal';
import '@Global/notifications';
import type {ReactElement} from 'react';
import React from 'react';
import App from '@Components/app';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {ModalContainer} from '@Components/modal-container';
import {LoadingToast} from '@Components/loading-toast';
import type {SharePanelProps} from '@Panels/share-panel/share-panel.types';
import {ShareItemType} from '@Panels/share-panel/share-panel.types';
import {openSharingModal} from '@Modals/share-modal/share-modal-library';
import {DownloadLoadingPopup} from '@Components/download-panel/components/download-loading-popup/download-loading-popup';
import {renderApp} from '@Utils/renderApp.util';
import {openMultipageTemplateSubmissionUnavailableModal} from '@Modals/multipage-template-submission-unavailable-modal/multipage-template-submission-unavailable-modal.library';

window.PMW.mergePMW(PMW, {
  openSharePosterModal: (props: SharePanelProps): void => {
    openSharingModal({...props, type: ShareItemType.POSTER});
  },
  openMultipageTemplateSubmissionUnavailableModal: (posterHashedId: string): void => {
    openMultipageTemplateSubmissionUnavailableModal({posterHashedId});
  }
});

export function PosterViewApp(): ReactElement {
  return (
    <App>
      <ModalContainerDeprecated />
      <ModalContainer />
      <LoadingToast />
      <DownloadLoadingPopup />
    </App>
  );
}

renderApp(<PosterViewApp />, 'poster-view-app');
